module.exports = __webpack_public_path__ + "static/media/cellfinate_imagen_hoyuelos.d8550ddb.jpg";